module.exports = {"login":{"signin":"Sign in with o365","title":"Login","logout":"Logout","loginFail":"Login Fail","getUserInfoFail":"Get User Info Fail From Microsoft Graph"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/login.json
// module id = 531
// module chunks = 10